exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list-romaneio[data-v-4c2a8d54] {\n  width: 100%;\n}\n", ""]);

// exports
